import React from "react";

function AboutTitle() {
	return (
		<div style={{marginTop: 40, marginBottom: 20}}>
			<h1 style={{ textAlign: "center", fontWeight: 300 }}>Botta Gioielli History</h1>
		</div>
	);
}

export default AboutTitle;
